<template>
  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Leave</span></h4>
    </div>

        <div class="mt-5">
            <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
                <b-tab lazy title="Pending Approval">
                    <div class="">
                        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
                            <h4 class="clearfix">
                                <span class="float-left">Leave Request List (Pending Approval)
                                    <span class="title-sub-text">Track and Manage Leave Requests.</span>
                                </span>
                                <span class="float-right"></span>
                            </h4>
                        </div>

                        <roster-roster-leaves-list-applied :roster="roster == 1" :key="list_key"  v-on:childToParent="listReturn"></roster-roster-leaves-list-applied>
                    </div>
                </b-tab>
                <b-tab lazy title="Approved">
                    <div class="">
                        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
                            <h4 class="clearfix">
                                <span class="float-left">Leave Request List (Approved)
                                    <span class="title-sub-text">Track and Manage Leave Requests.</span>
                                </span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <roster-roster-leaves-list-approved :roster="roster == 1" :key="list_key_1"  v-on:childToParent="listReturn"></roster-roster-leaves-list-approved>
                    </div>
                </b-tab>
                <b-tab lazy title="Declined">
                    <div class="">
                        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
                            <h4 class="clearfix">
                                <span class="float-left">Leave Request List (Declined)
                                    <span class="title-sub-text">Track and Manage Leave Requests.</span>
                                </span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <roster-roster-leaves-list-declined :roster="roster == 1" :key="list_key_2"  v-on:childToParent="listReturn"></roster-roster-leaves-list-declined>
                    </div>
                </b-tab>
            </b-tabs>
        </div>

        </div>
</template>
<script>
    import moment from 'moment'
    export default{

        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;

            }
        },
        props: ['roster'],
        components: {},
        data(){
            /** Sohel Code Starts Here */
            let sortOrders = {};
            let columns = [
                            {label: 'Employee', name: 'employee_name' },
                            {label: 'Job Position', name: 'employee_code' },
                            {label: 'Department', name: 'department' },
                            {label: 'Leave Category', name: 'leave_type'},
                            {label: 'From', name: 'from'},
                            {label: 'To', name: 'to'},
                            {label: 'No of Days', name: 'number_of_days'},
                            {label: 'Reason', name: 'reason'},
                            {label: 'Status', name: 'status'},
                            {label: 'Updated By', name: 'updated_by'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            /** Sohel Code Ends Here */

            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            const minDate = new Date(today);
            minDate.setMonth(minDate.getMonth());
            minDate.setDate(minDate.getDate());
            const startdate = minDate;
            var startDate = '';
            var endDate = '';
            //var today = new Date();
            if ((today.getMonth() + 1) <= 6)
            {
                startDate = (today.getFullYear() - 1) + '-07-1';
                endDate = (today.getFullYear()) + '-06-30';
            }
            else
            {
                startDate = (today.getFullYear()) + '-07-1';
                endDate = (today.getFullYear() + 1) + '-06-30';
            }

            return {
                depertments:[],
                search_by_id:{department_id:0, leave_type_id:0 , flg_status:0},
                startDate : startDate,
                endDate : endDate,
                min: minDate,
                day_one: moment(String(startdate)).format('YYYY-MM-DD') ,
                day_two: moment(String(startdate)).format('YYYY-MM-DD') ,
                all_week_holidays : [],
                week_start_day : 7,
                holidays_date_arr : [],
                leavetypes: [],
                flg_status : [
                            { text: 'Applied', value: '0' },
                            { text: 'Approved', value: '1' },
                            { text: 'Declined', value: '2' },
                        ],

                /** Sohel Code Starts Here */
                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders,
                /** Sohel Code Ends Here */

                leaves:[],

                showoverlay:false,
                showoverlay_list:false,
                movenext : false,

                errormsg:[],
                fdata: {  },
                //

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                ce : true,
                employee_id : 0,
                list_key:0,
                list_key_1:100,
                list_key_2:200,

                approved_leaves_today : 0,
                pending_leaves_today : 0,
                pending_leaves_fiscal_year : 0,


                tmp_leave_type_id : 0,
                tmp_flg_status : 0,
                tmp_from : '',
                tmp_to : '',


                start_date: null,
                end_date: null,
                lv : [],
                this_month_holidays : [],
                this_month : 1,
                this_year : 2020,
                weekly_holidays : [6],
                first_day_of_week : 7,
                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',


                masks :
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dot: 'pink',
                            dates: new Date(),
                        }
                    ],
            }
        },
        methods:{
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            listReturn:function(data)
            {
                this.list_key = this.list_key + 1;
                this.list_key_1 = this.list_key_1 + 1;
                this.list_key_2 = this.list_key_2 + 1;
            },
            monthDetails: function(x)
            {
                let currentObj = this;
                let year = x['year'];
                let month = x['month'];
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);

                this.this_month = x['month'];
                this.this_year = x['year'];

                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');

                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/leave-attendance/holidays/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.weekly_holidays = response.data.report.weekly_holidays;
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;

                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.weekend_color_code = response.data.report.weekend_color_code;
                    this.holiday_color_code = response.data.report.holiday_color_code;




                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            },
            importLeaves: function()
            {
                this.$bvModal.show('bv-modal-import-leave');
            },
            uploadLeaveFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/employee/leave/import/import', data , config).
                    then(function (response){



                        this.$bvToast.toast('Successfully Imported', {
                                            title: `Success`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.showoverlay = false;
                        this.$bvModal.hide('bv-modal-import-leave');

                        this.getLeaves();

                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    this.showoverlay = false;
            },
            getLeaves: function()
            {
                if(!this.checkNet()) return false;

                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url+'/leave-attendance/employee/leaves/fiscalyear' , {
                    params: {
                        search_by_id: this.search_by_id
                    }
                }).then(function(response){
                    this.leaves = response.data.leaves;
                    this.employee_id = response.data.employee_id;

                    this.approved_leaves_today = response.data.approved_leaves_today;
                    //this.pending_leaves_today = response.data.pending_leaves_today;
                    this.pending_leaves_fiscal_year = response.data.pending_leaves_today;

                    this.$bvModal.hide('bv-modal-edit-leave');
                    this.$bvModal.hide('bv-modal-add-leave');


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            getApprovePendingLeavesToday: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/leave-attendance/approve-pending/leaves/today' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.approved_leaves_today = response.data.approved_leaves_today;
                    this.pending_leaves_today = response.data.pending_leaves_today;
                    this.pending_leaves_fiscal_year = response.data.pending_leaves_fiscal_year;


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            setEmployee: function(x)
            {
                this.employee_id = x.employee_id;
            },
            addNew()
            {
                this.employee_id = 0;
                this.$bvModal.show('bv-modal-add-leave');
            },

            //editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)
            editLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.employee_id = 0;
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {
                        this.employee_id = employee_id;

                        this.tmp_leave_type_id = leave_type_id;
                        this.tmp_flg_status = flg_status;
                        this.tmp_from = from;
                        this.tmp_to = to;

                        this.$bvModal.show('bv-modal-edit-leave');

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            updateLeave: function(employee_id , leave_type_id , flg_status , from , to , status)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.employee_id = 0;
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('flg_status' , flg_status);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('status' , status);

                axios.post(this.$api_url+'/leave-attendance/employee/leaves/status', formData)
                    .then(function (response)
                    {
                        this.getLeaves();

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('flg_status' , flg_status);



                axios.post(this.$api_url+'/leave-attendance/leave/delete/range', formData)
                    .then(function (response)
                    {
                        this.$bvToast.toast('Deleted!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });


                        this.getLeaves();
                        //this.getApprovePendingLeavesToday();

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },



            getDepertments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));

            },

            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                return this.all_week_holidays.includes(x) || this.holidays_date_arr.includes(x);
            },
            updateToDate:function()
            {
                this.day_two = this.day_one;
                this.min = this.day_one;
            },
            checkValidDate:function()
            {
                if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                    this.updateToDate();
            },

            getDisabledDates:function()
            {
                axios.get(this.$api_url+'/leave-attendance/holidays/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)                    {
                        this.all_week_holidays = response.data.report.week_holidays;
                        this.week_start_day =  response.data.report.week_start_day;
                        this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    }
                }.bind(this));
            },
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/leave-attendance/leave/types' , {

                }).then(function(response){

                    this.leavetypes = response.data;
                }.bind(this));
            },

            resetFlter : function()
            {
                this.day_one = '';
                this.day_two = '';

                this.search_by_id.day_one = '';
                this.search_by_id.day_two = '';
                this.search_by_id.department_id = 0;
                this.search_by_id.leave_type_id = 0;
                this.search_by_id.flg_status = -1;
                this.getLeaves();
                this.$root.$emit('bv::toggle::collapse', 'sidebar_right');
            },
            setFlter : function()
            {
                this.search_by_id.day_one = this.day_one;
                this.search_by_id.day_two = this.day_two;
                this.getLeaves();
                this.$root.$emit('bv::toggle::collapse', 'sidebar_right');
            }






        },
        created: function(){

            // this.getDepertments();
            // this.getLeaveTypes();
            // this.resetFlter();
            // this.getDisabledDates();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leaves;
                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type == 'date')
                            {
                                return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type == 'number')
                            {
                                return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a == b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        }
    }
</script>
